const currencies = {
  INR: "₹",
}

export default currencies
